// ================================================================
//  <bm-stat-tile> — one shared "value + label (+ optional bar, + optional
//  trend arrow)" card, for every stats/metrics tile grid in the app
//  (Consolidated Stats, Environment Status, Agent Details, ...).
//
//  Before this component, the exact same tile shell (value/label/border/
//  radius/padding, plus a pressure-bar-track/fill variant, plus a
//  trend-arrow variant) was hand-rolled 3 times under 3 different prefixes
//  (.csd-tile, .esd-tile, and a 4th about to be added for Agent Details) —
//  all pixel-identical in intent, quietly drifting in practice (esd's
//  trend arrow sits inline next to the value; csd's sits in its own column
//  on the right). This is the one place that shell now lives.
//
//  Formatting stays with the CALLER (each dialog already has its own
//  avgFrameRateLabel/avgPingTimeLabel/bmCompactNumber-style helpers) — this
//  component only renders whatever string it's handed. Likewise bar/trend
//  COLOR is computed by the caller (pressureColor/ratioColor filters,
//  getLogPressureColor(), or a literal gradient for a static metric like
//  CPU/Memory) and passed straight through to ng-style — this component
//  has no opinion on what color a given value deserves.
//
//  Usage:
//    <bm-stat-tile value="{{ vm.avgFrameRateLabel(x) }}" label="Avg Frame Receive Rate"
//                  tooltip="Frames captured per minute.">
//    </bm-stat-tile>
//
//    <!-- Bar variant -->
//    <bm-stat-tile value="{{ pct }}%" label="Load Pressure"
//                  bar-percent="pct" bar-color="{{ pct | pressureColor }}">
//    </bm-stat-tile>
//
//    <!-- Bar + trend arrow, small (inline next to the value — esd's style) -->
//    <bm-stat-tile value="{{ pct }}%" label="Avg Pressure"
//                  bar-percent="pct" bar-color="{{ pct | pressureColor }}"
//                  trend-icon="{{ vm.trendIcon(trend) }}" trend-direction="{{ trend }}">
//    </bm-stat-tile>
//
//    <!-- Bar + trend arrow, large (own column on the right — csd's style) -->
//    <bm-stat-tile value="{{ pct }}%" label="Average Pressure"
//                  bar-percent="pct" bar-color="{{ pct | pressureColor }}"
//                  trend-icon="{{ vm.trendIcon(trend) }}" trend-direction="{{ trend }}"
//                  trend-size="lg">
//    </bm-stat-tile>
//
//  Bindings:
//    value         (@) required — pre-formatted display string (may include a unit).
//    label         (@) required — uppercase caption under the value.
//    tooltip       (@) optional — md-tooltip text; omitted entirely when blank.
//    warn          (<) boolean — renders the value in the "bad" red, for a
//                  dimension that's always concerning when non-zero (e.g.
//                  Dropped frames), independent of any bar.
//    barPercent    (<) 0-100, or undefined/null for no bar at all.
//    barColor      (@) CSS color/gradient for the fill — required if barPercent is set.
//    trendIcon     (@) a material-icon ligature ('arrow_upward'/'arrow_downward'),
//                  or falsy for no trend arrow at all.
//    trendDirection (@) 'UP'/'DOWN'/'FLAT'/'UNKNOWN' — colors the arrow
//                  (UP is always the red "worse" direction, DOWN the green
//                  "better" one, regardless of which metric it's attached to).
//    trendSize     (@) 'lg' for the large side-column icon (csd's original
//                  layout); omitted/anything else for the small inline icon
//                  next to the value (esd's original layout).
// ================================================================

angular.module('bizmetryApp').component('bmStatTile', {
  bindings: {
    value: '@',
    label: '@',
    tooltip: '@',
    warn: '<',
    barPercent: '<',
    barColor: '@',
    trendIcon: '@',
    trendDirection: '@',
    trendSize: '@'
  },
  template: `
    <div class="bm-stat-tile"
         ng-class="[$ctrl.warn ? 'bm-stat-tile--warn' : '', ($ctrl.trendIcon && $ctrl.trendSize === 'lg') ? 'bm-stat-tile--trend-row' : '', $ctrl.tooltip ? 'bm-stat-tile--has-tooltip' : '']">
      <div class="bm-stat-tile-main">
        <span class="bm-stat-tile-value">
          {{ $ctrl.value }}
          <md-icon ng-if="$ctrl.trendIcon && $ctrl.trendSize !== 'lg'"
                   class="material-icons bm-stat-tile-trend-icon-sm bm-stat-tile-trend-icon-sm--{{ ($ctrl.trendDirection || '') | lowercase }}">{{ $ctrl.trendIcon }}</md-icon>
        </span>
        <span class="bm-stat-tile-label">{{ $ctrl.label }}</span>
        <div class="bm-stat-tile-bar-track" ng-if="$ctrl.barPercent !== undefined && $ctrl.barPercent !== null">
          <div class="bm-stat-tile-bar-fill" ng-style="{ width: ($ctrl.barPercent || 0) + '%', background: $ctrl.barColor }"></div>
        </div>
      </div>
      <md-icon ng-if="$ctrl.trendIcon && $ctrl.trendSize === 'lg'"
               class="material-icons bm-stat-tile-trend-icon-lg bm-stat-tile-trend-icon-lg--{{ ($ctrl.trendDirection || '') | lowercase }}">{{ $ctrl.trendIcon }}</md-icon>
      <md-tooltip md-direction="top" ng-if="$ctrl.tooltip">{{ $ctrl.tooltip }}</md-tooltip>
    </div>
  `
});
